module.exports = __webpack_public_path__ + "media/images/application/template/brick-awards-8514df8b4a672926b3fb0124def60230.png";